var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9BADBC",
    fillRule: "evenodd",
    d: "M8.277 1.076l5.316 8.638A1.5 1.5 0 0112.316 12H1.684A1.5 1.5 0 01.407 9.714l5.316-8.638a1.5 1.5 0 012.554 0zM8 10a1 1 0 10-2 0 1 1 0 002 0zM6.34 3c-.186-.002-.338.116-.34.263v.014l.304 4.474c.012.141.16.25.34.249h.713c.178.001.327-.108.339-.25L8 3.278c.008-.147-.136-.27-.321-.277h-1.34z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default ForwardRef;